"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Progress;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _classnames = _interopRequireDefault(require("classnames"));

var _MultiProgressCircle = _interopRequireDefault(require("../../MultiProgressCircle/MultiProgressCircle"));

var _getProgress = _interopRequireDefault(require("../utils/getProgress"));

var s = {
  progressContainer: function progressContainer(type) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("display:flex;align-items:flex-end;", type !== 'Wide' ? "\n      line-height: 1;\n      margin-top: 10px;" : '')
    );
  },
  progressText: function progressText(theme, isMobile) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("font-size:", isMobile ? '12px' : '14px', ";color:", theme.color.dark.amethyst, ";margin-left:8px;line-height:1;")
    );
  }
};

function Progress(props, key) {
  var theme = props.theme,
      isMobile = props.isMobile,
      customClassName = props.customClassName;
  var progress = (0, _getProgress.default)(props);

  if (!progress || progress <= 0) {
    return null;
  }

  return _react.default.createElement("div", {
    key: key,
    className: s.progressContainer(props.type)
  }, _react.default.createElement(_MultiProgressCircle.default, {
    size: isMobile ? 13 : 16,
    sections: [{
      progress: progress,
      color: theme.color.dark.amethyst
    }],
    isDark: true,
    strokeWidth: 10
  }), _react.default.createElement("span", {
    className: (0, _classnames.default)(s.progressText(theme, isMobile), customClassName)
  }, Math.floor(progress * 100), "%"));
}